module.exports = __webpack_public_path__ + "media/images/spinner-997c80afc53e7ed7478576c5950ac470.gif";